export default __webpack_public_path__ + "static/media/QSGRW_Imagery_GreyScale.69eb2fd8.png";